import { useLocalSearchParams } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { SuccessScreen } from '@/components/SuccessScreen';
import { Header } from '@/components/header';
import { VStack } from '@/components/ui/vstack';
import { ROUTES } from '@/constants/routes';
import { useColors } from '@/hooks/useColors';
import { useRedirectPath } from '@/hooks/useRedirectPath';

export default function Success() {
  const { email } = useLocalSearchParams<{ email: string }>();

  const { colors } = useColors();

  const { bottom } = useSafeAreaInsets();

  const { appendRedirectPath } = useRedirectPath();

  return (
    <VStack className="flex-1 bg-primary-500" style={{ paddingBottom: bottom }}>
      <Header
        headerShown={false}
        statusBarBackgroundColor={colors.primary[500]}
        statusBarStyle="light"
        contentStyle={{ backgroundColor: colors.primary[500] }}
      />

      <SuccessScreen
        heading="Thank you!"
        description={`An email has been sent to ${email ?? 'your address'} with instructions to complete resetting your password.`}
        riveAnimation="LOGO_FLOW_LIGHT_GREEN"
        buttonText="Sign in"
        buttonHref={appendRedirectPath(ROUTES.LOGIN)}
      />
    </VStack>
  );
}
